import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams, AccountingReport } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseUpcomingRevenueProps {
  dueDateStart: string | null;
  dueDateEnd: string | null;
  productType?: string | null;
  billingSources?: string[];
  paymentMethods?: string[];
  enabled?: boolean;
}

function useUpcomingRevenue({
  dueDateStart,
  dueDateEnd,
  productType,
  billingSources,
  paymentMethods,
  enabled = true,
}: IUseUpcomingRevenueProps): UseQueryResult<{ data: AccountingReport }> {
  const params: UrlParams = {};

  if (dueDateStart !== null) {
    params.start_date = dueDateStart;
  }
  if (dueDateEnd !== null) {
    params.end_date = dueDateEnd;
  }
  if (productType !== undefined && productType !== null) {
    params.product_type = productType;
  }
  if (billingSources !== undefined && billingSources.length > 0) {
    params.billing_sources = billingSources.join(',');
  }
  if (paymentMethods !== undefined && paymentMethods.length > 0) {
    params.payment_methods = paymentMethods.join(',');
  }

  return useQuery(
    ['upcoming-revenue', dueDateStart, dueDateEnd, productType, billingSources, paymentMethods],
    () => client.get(`reports/upcoming-revenue?${encodeUrlParams(params)}`),
    {
      enabled: enabled && dueDateStart !== null && dueDateEnd !== null,
      staleTime: 86400000, // 1 day
    },
  );
}

export default useUpcomingRevenue;
